(function() {
    'use strict';

    angular
        .module('app.layout')
        .filter('filterLocations', filterLocations)
        .directive('pickupLocations', pickupLocations);

    /* @ngInject */
    function filterLocations() {
        return function(locations, query) {

            if (!angular.isString(query) || query.trim() === '') {
                return locations;
            }

            // function checkAndPickValue(field, key) {
            //     if (angular.isObject(field) && angular.isString(field.value)) {
            //         return field.value.toLocaleLowerCase();
            //     }

            //     return '';
            // }

            var queryLower = query.toLocaleLowerCase();

            return locations.filter(function(location) {
                var data = location.data;
                if(
                    (data['site-no'].toLocaleLowerCase().indexOf(queryLower) !== -1) ||
                    (data.city.toLocaleLowerCase().indexOf(queryLower) !== -1) ||
                    (data.address.toLocaleLowerCase().indexOf(queryLower) !== -1) ||
                    (location.title.toLocaleLowerCase().indexOf(queryLower) !== -1)
                )   {
                    return true;
                }

                return false;
            });
        };
    }

    /* @ngInject */
    function pickupLocations($q, $window, dateFilter, $sce) {
        var directive = {
            bindToController: true,
            templateUrl: 'pickup-locations.tpl',
            controller: pickupLocationsController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            var _pinActive,
                _pinGrey,
                _defaultCenter,
                _isMobile,
                _defaultZoom = 11,
                _mapSettings = scope.$root.globals.site_options.maps;
            scope.vm.filteredLocations = null;
            scope.vm.locations = [];
            scope.vm.activeLocation = null;
            scope.vm.searchText = null;
            scope.vm.showMobileInfoOverlay = false;

            // do nothing if api key missing in maps settings

            if (
                !angular.isObject(_mapSettings) ||
                !angular.isString(_mapSettings.api_key) ||
                _mapSettings.api_key.trim() === ''
            ) {
                return console.error("Map API Key missing");
            }

            if ($window.matchMedia) {
                var mql = $window.matchMedia('only screen and (max-width: 767px)');
                _isMobile = mql.matches;
                mql.addListener(function(mql) {
                    _isMobile = mql.matches;
                });
            }

            scope.vm.selectLocation = function(event, loc) {
                event.stopPropagation();

                if(scope.vm.activeLocation === null || scope.vm.activeLocation.id !== loc.id) {
                    // scope.map.setCenter(loc.marker.position);
                    scope.map.panTo(loc.marker.position);
                    scope.vm.activeLocation = loc;
                    setActiveMarker();
                }

                //openMobileInfoOverlay();
            };

            scope.vm.resetSearch = function(event) {
                event.stopPropagation();
                scope.vm.searchText = '';
                element.find("#pick-locations-list").scrollTop(0);
                scope.resetMarkers();
            };

            scope.safeApply = function(fn) {
                var phase = this.$root.$$phase;
                if(phase == '$apply' || phase == '$digest') {
                    if(fn) {
                        fn();
                    }
                } else {
                    this.$apply(fn);
                }
            };

            scope.vm.getHours = function(params, ends) {
                var output = scope.$root.formatHours(params, ends);
                return $sce.trustAsHtml(output === '' ? '' : output);
            };

            scope.resetMarkers = function() {
                scope.vm.activeLocation = null;

                scope.vm.locations.forEach(function(l) {
                    l.marker.setVisible(false);
                });

                if(scope.vm.filteredLocations.length === 0) {
                    scope.map.setCenter(_defaultCenter);
                    scope.map.setZoom(_defaultZoom);
                } else if (scope.vm.filteredLocations.length === 1) {
                    var m = scope.vm.filteredLocations[0].marker;
                    m.setVisible(true);
                    m.setIcon(_pinActive);
                    scope.map.setCenter(m.getPosition());
                } else {
                    var bounds = new google.maps.LatLngBounds();
                    scope.vm.filteredLocations.forEach(function(fl) {
                        fl.marker.setVisible(true);
                        fl.marker.setIcon(_pinActive);
                        bounds.extend(fl.marker.position);
                    });

                    scope.map.fitBounds(bounds);
                    // scope.map.panToBounds(bounds);
                }
            };

            function setActiveMarker() {
                scope.vm.filteredLocations.forEach(function(l) {
                    if (l.id !== scope.vm.activeLocation.id) {
                        l.marker.setIcon(_pinGrey);
                        l.marker.setZIndex(1);
                    } else {
                        l.marker.setIcon(_pinActive);
                        l.marker.setZIndex(100);
                    }
                });
            }

            function openMobileInfoOverlay() {
                if (_isMobile === false) { return; }
                scope.vm.showMobileInfoOverlay = true;
                scope.safeApply();
            }

            function attachMarkerClickEvent(marker) {
                marker.addListener('click', function() {
                    if (scope.vm.activeLocation === null || scope.vm.activeLocation.id !== marker.loc.id) {
                        scope.vm.activeLocation = marker.loc;
                        setActiveMarker();
                        scrollActiveListItem();
                        scope.safeApply();
                    }

                    //openMobileInfoOverlay();
                });
            }

            function scrollActiveListItem() {
                // console.log(scope.vm.activeLocation.id);
                var item = element.find('.pickup-locations-list-item[id=' + scope.vm.activeLocation.id + ']');
                // console.log(item);
                if (item.length !== 0) {
                    var list = element.find(scope.$root.project_has_opt('neighborhood') ? '.state-list-wrap' : '.pickup-locations-list');
                    list.animate({
                        scrollTop: item.offset().top - list.offset().top + list.scrollTop() - 80
                    });
                }
            }



            function parseLocations(locs) {
                if (typeof locs.locations == 'undefined') {
                    return;
                }
                var bounds = new google.maps.LatLngBounds();
                for (var i = 0; i < locs.locations.length; i++) {
                    var locData = locs.locations[i];
                    if(!locData.private) {
                        if (!locData.lat || !locData.lng) {
                            continue;
                        }
                        var LatLng = {lat: locData.lat, lng:locData.lng};

                        var l = {
                            title: angular.element('<textarea />').html(locData.title).text(), // convert special chars
                            id: "loc" + i,
                            data : locData
                        };

                        var marker = new google.maps.Marker({
                            map: scope.map,
                            position: LatLng,
                            icon: _pinActive,
                            loc: l
                        });
                        l.marker = marker;
                        attachMarkerClickEvent(marker);
                        scope.vm.locations.push(l);
                        bounds.extend(marker.position);
                    }
                }
                scope.vm.filteredLocations = scope.vm.locations;
                scope.safeApply();

                if (scope.$root.project_has_opt('neighborhood')) {
                    scope.vm.filteredLocationsState = {};
                    scope.vm.filteredLocations.forEach(function(l) {
                        if (typeof l.data.state != 'undefined') {
                            if (typeof scope.vm.filteredLocationsState[l.data.state] == 'undefined') {
                                scope.vm.filteredLocationsState[l.data.state] = [];
                            }
                            scope.vm.filteredLocationsState[l.data.state].push(l);
                        }
                    });
                    // console.log(scope.vm.filteredLocationsState);
                    scope.vm.states = Object.keys(scope.vm.filteredLocationsState).sort();
                    scope.vm.states.forEach(function(s) {
                        scope.vm.filteredLocationsState[s].sort(function(a, b) {
                            return a.data.nh > b.data.nh ? 1 : 0;
                        });
                    });
                }

                scope.map.fitBounds(bounds);
            }

            function initializeMap() {

                var mapStyle = [{
                    'stylers': [{ 'saturation': -100 }, { 'gamma': 1 }]
                }, {
                    'elementType':'labels.text.stroke',
                    'stylers':[{ 'visibility': 'off' }]
                }, {
                    'featureType':'road',
                    'elementType':'geometry',
                    'stylers':[{ 'visibility': 'simplified' }]
                }];

                _defaultCenter = new google.maps.LatLng(parseFloat(_mapSettings.default_location.lat), parseFloat(_mapSettings.default_location.lng));
                _pinActive = {
                    url: '/wp-content/themes/pie/img/icons/pin-' + scope.$root.globals.site_options.project_slug +  '.png',
                    size: new google.maps.Size(37, 33),
                    scaledSize: new google.maps.Size(37, 33),
                    anchor: new google.maps.Point(12, 33)
                };
                scope.vm.mobilePin = _pinActive.url;
                _pinGrey = {
                    url: '/wp-content/themes/pie/img/icons/pin-grey.png',
                    size: new google.maps.Size(37, 33),
                    scaledSize: new google.maps.Size(37, 33),
                    anchor: new google.maps.Point(12, 33)
                };

                var mapOptions = {
                    zoom: _defaultZoom,
                    center: _defaultCenter,
                    styles: mapStyle,
                    disableDefaultUI: true,
                    zoomControl: true,
                    mapTypeControl: false,
                    gestureHandling: 'greedy',
                    mapTypeControlOptions: {
                        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
                        mapTypeIds: ['roadmap', 'terrain']
                    }
                };
                scope.map = new google.maps.Map(document.getElementById('map-container'), mapOptions);
            }

            // ---

            var locations = {};
            var query = scope.vm.data.query[0];
            if (angular.isObject(query) && query.customs && query.customs['pickup-locations']) {
                locations = query.customs['pickup-locations'];
            } else {
                console.error("missing pick-up locations");
            }

            function start () {
                setTimeout(function() {
                    initializeMap();
                    parseLocations(locations);
                    scope.resetMarkers();
                }, 10);
            }


            if ((typeof google == 'undefined') || (typeof google.maps == 'undefined')) {
                scope.$root.loadGoogleMap(function() {
                    start();
                });
            } else {
                start();
            }

            // ----


        }
    }

    /* @ngInject */
    function pickupLocationsController ($scope, $http) {
        $scope.$watch('vm.searchText', function(value) {
            if (value !== null) {
                var queryLower = value.toLocaleLowerCase();
                $scope.vm.filteredLocations = $scope.vm.locations.filter(function(loc) {
                    return (
                        ($scope.$root.safeChain(loc.data,'site-no').indexOf(queryLower) !== -1) ||
                        ($scope.$root.safeChain(loc.data,'city').toLocaleLowerCase().indexOf(queryLower) !== -1) ||
                        ($scope.$root.safeChain(loc,'title').toLocaleLowerCase().indexOf(queryLower) !== -1) ||
                        ($scope.$root.safeChain(loc.data,'address').toLocaleLowerCase().indexOf(queryLower) !== -1) ||
                        ($scope.$root.safeChain(loc.data,'nh').toLocaleLowerCase().indexOf(queryLower) !== -1) ||
                        ($scope.$root.safeChain(loc.data,'state').toLocaleLowerCase().indexOf(queryLower) !== -1)
                    );
                });

                if ($scope.vm.filteredLocations.length == 0) {
                    if ($scope.$root.project_has_opt('zipGeodata')) {
                        if (value) {
                            var v  = value.toLocaleLowerCase().trim();
                            if (/^\d{5}$/.test(v)) {
                                console.log('geolocation');
                                $scope.frameByZip(v);
                                return;
                            }
                        }
                    }
                }

                $scope.resetMarkers(false);
                if ($scope.$root.project_has_opt('neighborhood')) {
                    $scope.vm.filteredLocationsState = {};
                    $scope.vm.filteredLocations.forEach(function(l) {
                        if (typeof $scope.vm.filteredLocationsState[l.data.state] == 'undefined') {
                            $scope.vm.filteredLocationsState[l.data.state] = [];
                        }
                        $scope.vm.filteredLocationsState[l.data.state].push(l);
                    });

                    $scope.vm.states.forEach(function(s) {
                        if (typeof $scope.vm.filteredLocationsState[s] != 'undefined') {
                            $scope.vm.filteredLocationsState[s].sort(function(a, b) {
                                return a.data.nh > b.data.nh ? 1 : 0;
                            });
                        }
                    });

                }
            }
        });

        $scope.frameByZip = function(zip) {
            function distance(p1, p2) {
                var R = 3958.8;
                var rlat1 = p1.lat * (Math.PI / 180);
                var rlat2 = p2.lat * (Math.PI / 180);
                var difflat = rlat2 - rlat1;
                var difflng = (p2.lng - p1.lng) * (Math.PI / 180);
                return 2 * R * Math.asin(Math.sqrt(Math.sin(difflat / 2) * Math.sin(difflat / 2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflng / 2) * Math.sin(difflng / 2)));
            }

            $http.post(ajaxurl, {
                action: 'pie_action',
                method: 'get_bounds',
                nonce: $scope.$root.stats.nonce,
                params: {
                    zip: zip
                }
            }).then(function(response) {
                if (response.data.result) {
                    var found = false;
                    var location = response.data.payload.location;
                    $scope.vm.locations.forEach(function(e) {
                        var d = distance(location, {lat: e.data.lat, lng: e.data.lng});
                        if (d <= 10) {
                            found = true;
                            $scope.vm.filteredLocations.push(e);
                        }
                    });
                    if (!found) {
                        $scope.vm.searchText = '';
                    }
                    $scope.resetMarkers(false);
                } else {
                    console.log(response.data.message);
                    $scope.vm.searchText = '';
                }
            });
        };

    }
})();